import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { roleHome } from "@/lib/constants";
import { Gem } from "lucide-react";
import { toast } from "sonner";

const INTERNAL = ["owner", "admin", "manager"];

export default function ProtectedRoute({ children, allow = "internal" }) {
  const { user, loading } = useAuth();

  const denied = user && (
    (allow === "client" && user.role !== "client") ||
    (allow === "crew" && user.role !== "crew") ||
    (allow === "internal" && !INTERNAL.includes(user.role))
  );

  useEffect(() => {
    if (denied) toast.error("Anda tidak memiliki akses ke halaman tersebut.");
  }, [denied]);

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <div className="flex flex-col items-center gap-3 animate-pulse">
          <div className="w-12 h-12 rounded-full bg-burgundy flex items-center justify-center">
            <Gem className="w-6 h-6 text-white" strokeWidth={1.5} />
          </div>
          <p className="font-heading text-xl text-burgundy">Primrose Organizer</p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (denied) return <Navigate to={roleHome(user.role)} replace />;
  return children;
}
